import {useCallback, useState} from 'react';
import styles from './packageContent.module.css';
import {
    Icon,
    IconSizes,
    Icons,
    Typography,
} from '@toppy-webshop/toppy-design-system';
import {useI18nContext} from '../../i18n/i18n-react';

interface ProductLineProps {
    key: string;
    name: string;
    qty: number | null | undefined;
}

interface CollapsibleProductLineListProps {
    products: ProductLineProps[];
}

const ProductLine = ({qty, name}: ProductLineProps) => (
    <div>
        <span className={styles.quantity}>
            <Typography size={'s'} weight={'bold'}>
                {qty === undefined || qty === null ? `\u2022` : `${qty} x`}
            </Typography>
        </span>
        <span className={styles['product-name']}>
            <Typography size={'xs'}>{name}</Typography>
        </span>
    </div>
);

const CollapsibleProductLineList = (props: CollapsibleProductLineListProps) => {
    const {LL} = useI18nContext();
    const [showProducts, setShowProducts] = useState(false);
    const handleClick = useCallback(() => {
        setShowProducts(current => !current);
    }, []);

    return (
        <div>
            {showProducts && (
                <div className={styles['products-list']}>
                    {props.products.map((product, key) => (
                        <ProductLine {...product} key={product.key} />
                    ))}
                </div>
            )}
            <button className={styles['products-button']} onClick={handleClick}>
                {showProducts && (
                    <Icon icon={Icons.CH_UP} size={IconSizes.XS} />
                )}
                {!showProducts && (
                    <Icon icon={Icons.CH_DOWN} size={IconSizes.XS} />
                )}
                <span className={styles['button-text']}>
                    <Typography size={'xs'} weight={'bold'}>
                        {LL.shipment.items.numberOfItems({
                            count: props.products.length,
                        })}
                    </Typography>
                </span>
            </button>
        </div>
    );
};

export default CollapsibleProductLineList;
